module.exports = __webpack_public_path__ + "img/ask_community.cffd311f.svg";